/** @format */

import {Box, Button} from '@mui/material';
import {styled} from '@mui/material/styles';

export const ContentWrapper = styled(Box)(({theme}) => ({
  width: '500px',
  maxWidth: 'calc(100vw - 32px)',
  backgroundColor: theme.palette.semantic_light?.surface.background,
}));

export const FormBody = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  padding: theme.spacing(4),
}));

export const DescriptionText = styled(Box)(({theme}) => ({
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  color: theme.palette.semantic_light?.surface.onSurface,
}));

export const DescriptionBlock = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const InputField = styled('input')(({theme}) => ({
  width: '100%',
  minHeight: '48px',
  border: `1px solid ${theme.palette.semantic_light?.primary.active}`,
  borderRadius: '8px',
  padding: theme.spacing(2),
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '22px',
  color: theme.palette.semantic_light?.surface.onSurface,
  backgroundColor: 'transparent',
  outline: 'none',
  boxSizing: 'border-box',

  '&::placeholder': {
    color: theme.palette.semantic_light?.surface.onSurfaceMuted,
  },
}));

export const SubmitButton = styled(Button)(({theme}) => ({
  width: '100%',
  height: '48px',
  borderRadius: '8px',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  textTransform: 'none',
  backgroundColor: theme.palette.semantic_light?.primary.main,
  color: theme.palette.semantic_light?.primary.on,

  '&:hover': {
    backgroundColor: theme.palette.semantic_light?.primary.hover,
  },

  '&.Mui-disabled': {
    backgroundColor: theme.palette.semantic_light?.disabled.disabledLow,
    color: theme.palette.semantic_light?.disabled.disabled,
  },
}));

export const SuccessBody = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(4),
  textAlign: 'center',
  gap: theme.spacing(4),
}));

export const SuccessContent = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '300px',
}));

export const SuccessIconWrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),

  '& .material-symbols-outlined': {
    fontSize: '72px',
    background: `linear-gradient(180deg, ${theme.palette.semantic_light?.good.main} 0%, ${theme.palette.semantic_light?.good.active} 100%)`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },
}));

export const SuccessTitle = styled(Box)(({theme}) => ({
  fontSize: '18px',
  fontWeight: 500,
  lineHeight: '22px',
  color: theme.palette.semantic_light?.good.main,
}));

export const SuccessDescription = styled(Box)(({theme}) => ({
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  color: theme.palette.semantic_light?.surface.onSurface,
  width: '100%',
}));

export const CloseButton = styled(Button)(({theme}) => ({
  width: '100%',
  borderRadius: '8px',
  padding: theme.spacing(3.5, 4),
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  textTransform: 'none',
  backgroundColor: theme.palette.semantic_light?.primary.main,
  color: theme.palette.semantic_light?.primary.on,

  '&:hover': {
    backgroundColor: theme.palette.semantic_light?.primary.hover,
  },
}));
